function Solutions() {
    return (
      <>

{/* Header Start */}
<div className="container-fluid bg-breadcrumb2">
<div className="bg-breadcrumb-single" />
<div className="container text-center py-5" style={{ maxWidth: 900 }}>
  <h4
    className="text-white display-4 mb-4 wow fadeInDown"
    data-wow-delay="0.1s"
  >
    Solutions
  </h4>
 
</div>
</div>
      <div className="container-fluid project">
        <div className="container-fluid">
          <div
            className="text-center mx-auto pb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: 800, marginTop : 40 }}
          >
            <h1 className="dispay-4">Explore Our Solutions</h1>
          </div>
          <div
              className="project-carousel owl-arousel wow fadeInUp"
              data-wow-delay="0.1s"
            >
<div className="col-md-4 project-item h-100 wow fadeInUp" data-wow-delay="0.1s">
                <div className="project-img">
                  <img
                    src="assets/img/dataflow1.jpg"
                    className="img-flid w-100 rouned"
                    alt="Image"
                  />
                </div>
                <div className="project-content bg-light rounded p-4">
                  <div className="project-content-inner">
                    <div className="project-icon mb-3">
                      <i className="fas fa-chart-line fa-4x text-primary" />
                    </div>
                    <p className="text-drk fs-5 b-3">Data flow management</p>
                    <a href="/" className="h4">
                      Optimize resource utilization by moving data between data
                      centers or between on-premises infrastructure and cloud...
                    </a>
                    <div className="pt-4">
                      <a className="btn btn-light rounded-pill py-3 px-5" href="/">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 project-item h-100 wow fadeInUp" data-wow-delay="0.1s">
                <div className="project-img">
                  <img
                    src="assets/img/cloud.jpg"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="project-content bg-light rounded p-4">
                  <div className="project-content-inner">
                    <div className="project-icon mb-3">
                      <i className="fas fa-chart-line fa-4x text-primary" />
                    </div>
                    <p className="text-dark fs-5 mb-3">Cloud Migration</p>
                    <a href="/" className="h4">
                    Because the continuous replication occurs in the background, with no performance disruption, the actual...
                    </a>
                    <div className="pt-4">
                      <a className="btn btn-light rounded-pill py-3 px-5" href="/">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 project-item h-100 wow fadeInUp" data-wow-delay="0.1s">
                <div className="project-img">
                  <img
                    src="assets/img/sap.png"
                    className="img-fluid w-100 rounded"
                    alt="Image"
                  />
                </div>
                <div className="project-content bg-light rounded p-4">
                  <div className="project-content-inner">
                    <div className="project-icon mb-3">
                      <i className="fas fa-chart-line fa-4x text-primary" />
                    </div>
                    <p className="text-dark fs-5 mb-3">SAP</p>
                    <a href="/" className="h4">
                    The Six Pillars of Modern Dynamic APM. APM in containerized World. Service Quality Management. Instana Success Story.
                    </a>
                    <div className="pt-4">
                      <a className="btn btn-light rounded-pill py-3 px-5" href="/">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>

 
        </div>
        </div>
        
        </div>   
  {/*- END CONTAINER-FLUID */}

   {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  <div className="container-fluid copyright py-3">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-md-6 text-center text-md-start mb-md-0">
                <span className="text-body">
                  <i className="fas fa-copyright text-light me-1" />
                  2024 Celersoft. All rights reserved.
                </span>
              </div>
              {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
            </div>
          </div>
        </div>
  {/* <a href="/Solutions" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

<button
  className="btn btn-primary btn-lg-square back-to-top"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
>
  <i className="fa fa-arrow-up" />
</button>


</>
    );
};

export default Solutions